<div class="modal-content version-modal">
  <div class="modal-header pt-3 px-4 pb-2 border-0">
    <div class="d-flex align-items-center">
      <img [src]="logoSrc" alt="AgenticCX" class="version-modal__logo" />
      <span class="version-modal__text-primary fw-semibold">{{ 'AgenticCX::AppName' | abpLocalization }}</span>
    </div>
  </div>
  <hr class="version-modal__divider" />

  <div class="modal-body p-4">
    <div *ngIf="isLoading" class="version-modal__loading text-center py-3">
      <i class="fa fa-spinner fa-pulse"></i>
    </div>

    <ng-container *ngIf="!isLoading">
      <div class="d-flex align-items-center gap-1 mb-2">
        <span class="version-modal__text-primary fw-semibold">
          {{ 'Settings::About:ProductVersion' | abpLocalization }}:
        </span>
        <span class="version-modal__text-secondary">
          {{ productVersion }}
        </span>
      </div>

      <a class="version-modal__details-link text-primary" (click)="toggleDetails()">
        {{ (showDetails ? 'Settings::About:HideDetails' : 'Settings::About:ShowDetails') | abpLocalization }}
      </a>

      <div *ngIf="showDetails" class="mt-3">
        <div
          *ngFor="let comp of versionInfo?.components; trackBy: trackByName"
          class="d-flex align-items-center gap-1 py-1"
        >
          <span class="version-modal__text-primary fw-semibold">{{ comp.name }}: </span>
          <span class="version-modal__text-secondary">{{ comp.version }}</span>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="modal-footer version-modal__footer py-3 px-4 justify-content-end border-0">
    <button type="button" class="btn btn-secondary" (click)="close()">
      {{ '::Close' | abpLocalization }}
    </button>
  </div>
</div>
